// Grid and projection constants
import { Size } from 'src/types';

/**
 * Base tile size before isometric projection
 */
export const UNPROJECTED_TILE_SIZE = 100;

/**
 * Multipliers for converting unprojected coordinates to isometric projection
 */
export const TILE_PROJECTION_MULTIPLIERS: Size = {
  width: 1.415,
  height: 0.819
};

/**
 * Tile size after isometric projection
 */
export const PROJECTED_TILE_SIZE = {
  width: UNPROJECTED_TILE_SIZE * TILE_PROJECTION_MULTIPLIERS.width,
  height: UNPROJECTED_TILE_SIZE * TILE_PROJECTION_MULTIPLIERS.height
};

/**
 * The boundaries of the search area for the pathfinder algorithm
 * is the grid that encompasses the two nodes + the offset below.
 */
export const CONNECTOR_SEARCH_OFFSET = { x: 1, y: 1 };

/**
 * Padding around the bounding box when exporting diagrams
 */
export const PROJECT_BOUNDING_BOX_PADDING = 3;
